import { InputGroupKeys } from 'store/customer/enums'
import { InputGroups } from 'store/customer/types'
import { useStoreSelector } from 'hooks/store'
import { selectInputGroup } from 'store/customer/slice'

/**
 * Custom hook to get a specific input group with typed return values based on the given key
 */
const useSelectInputGroup = <K extends InputGroupKeys>(inputGroupKey: K): InputGroups[K] => {
  // Redux store
  const inputGroup = useStoreSelector((store) => selectInputGroup(store, inputGroupKey))

  return inputGroup as InputGroups[K]
}

export default useSelectInputGroup
